module.exports = __webpack_public_path__ + "static/home-banner-img1-static-906eb2d10f7144082c3f742f3f83c74d.png";